import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

export const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const isHome = location.pathname === "/";

  const handleMenuClick = () => {
    setIsOpen(false);
  };

// Автоматически высчитываем высоту блока с навигацией
  useEffect(() => {
    const setNavHeight = () => {
      const nav = document.getElementById("menu");
      if (nav) {
        document.documentElement.style.setProperty(
          "--nav-height",
          `${nav.offsetHeight}px`
        );
      }
    };

    setNavHeight();
    window.addEventListener("resize", setNavHeight);

    return () => window.removeEventListener("resize", setNavHeight);
  }, [isOpen]);

  // Формируем ссылку в зависимости от того, на домашней  странице находимся или нет
  // из-за разного поведения якорных ссылок на главной странице и на внутренних страницах
  const renderNavLink = (hash, label) => (
    <li>
      {isHome ? (
        <a href={hash} className="page-scroll" onClick={handleMenuClick}>
          {label}
        </a>
      ) : (
        <Link to={`/${hash}`} className="page-scroll" onClick={handleMenuClick}>
          {label}
        </Link>
      )}
    </li>
  );

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className={`navbar-toggle ${isOpen ? "" : "collapsed"}`}
            aria-expanded={isOpen}
            onClick={() => setIsOpen(!isOpen)}
          >
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>

          <a href="https://www.yes35.ru" onClick={handleMenuClick}>
            <img
              src="https://yes35.ru/templates/aqua/images/logo-yes35.png"
              width="60"
              height="70"
              alt=""
            />
          </a>
        </div>

        <div className={`navbar-collapse collapse ${isOpen ? "in" : ""}`}>
          <ul className="nav navbar-nav navbar-right">
            {renderNavLink("#about", "О проекте")}
            {renderNavLink("#services", "Инструкторы")}
            {renderNavLink("#features", "Стоимость")}
            {renderNavLink("#testimonials", "Расписание")}
            {renderNavLink("#events", "Соревнования")}
            {renderNavLink("#portfolio", "Галерея")}
            {renderNavLink("#contact", "Контакты")}
          </ul>
        </div>
      </div>
    </nav>
  );
};
